<template>
  <div>
    <!-- 1.头部开始 -->
    <Banner />
    <cebianlan></cebianlan>
    <!-- 头部结束 -->
    <!-- banner开始 -->
    <div class="banner">
      <div style="overflow-x: auto;" class="w">
        <!-- 左边板块开始 -->
        <div class="zongshu">
          <div>
            <div class="head-sculpture" :style="{ backgroundImage: 'url(' + icon + ')' }"></div>
          </div>
          <div class="name">
            <h4 style="color: #262626">{{ nick_name }}</h4>
            <p>班课:&nbsp;&nbsp; {{ classNum }}门</p>
          </div>
          <NoticeQrCode
              :isEnableNotice="isEnableNotice"
              :uid="org_id"
              @closeQrCodeDialog="closeQrCodeDialog"
          />
          <div class="neirong">
            <!-- 受不了这狗屎代码了 操操操 好好好我来重构,算你牛逼 艹 -->
            <div class="ab" :class="currentIndex === index ? classMy : classB"
              v-show="!item.hide"
              v-for="(item, index) in listArr"
              :key="index"
              @click="selectList(item, index)"
              >
              <img :src="item.url" alt="图标" />
              <span v-if="index !== 1">{{ item.name }}</span>
              <p v-else style="display: flex;">
                <el-badge :value="unreadCount" v-if="unreadCount!=0">
                  <span>{{ item.name }}</span>
                </el-badge>
                <span v-else>{{ item.name }}</span>
              </p>
            </div>
          </div>
        </div>
        <!-- 左边板块结束 -->
        <pingtest v-show="currentIndex === 4"></pingtest>
        <!-- 左边板块结束 -->
        <oneVone v-show="currentIndex === 3"></oneVone>
        <!-- 我的课程 -->
        <course v-show="currentIndex === 0"></course>
        <!--我的笔记-->
        <MyNote v-show="currentIndex === 5"/>
        <MyHomework v-show="currentIndex === 1" @changeUnread="changeUnread"></MyHomework>
        <!-- 观看数据 -->
        <ViewDataCon v-if="currentIndex === 2" />
        <!-- 账户中心 -->
        <div v-show="currentIndex === 6">
          <div class="banner_r_h">
            <div class="bt">
              <h2>账户中心</h2>
            </div>
          </div>
          <!-- 右边头部结束-->
          <div class="banner_r_m">
            <div class="header">
              <ul>
                <li @click="aziliao()" :class="ziliao ? classA : classB">个人资料</li>
                <li @click="agaimi()" :class="gaimi ? classA : classB">修改密码</li>
                <li @click="abdwx()" :class="bdwx ? classA : classB">绑定微信</li>
              </ul>
            </div>
            <!-- 表单开始 -->
            <div v-show="ziliao" class="personal">
              <form action="">
                <div class="avatar">
                  <span class="title">头像</span>
                  <div class="avatar-img" v-if="icon" :style="{ backgroundImage: 'url(' + icon + ')' }">
                  </div>
                  <span @click="choosePic" class="avatar-change">更换头像</span>
                  <input type="file" style="display: none" ref="updateFile" @change="afterRead($event)" />
                </div>
                <div class="id">
                  <span class="title">用户ID</span>
                  <div class="id-content">
                    <input v-model="id" type="text" disabled />
                  </div>
                </div>
                <div class="nickname">
                  <span class="title">昵称</span>
                  <div class="nickname-content">
                    <input v-model="nick_name" type="text" placeholder="请输入昵称" />
                  </div>
                </div>
                <div class="gender">
                  <span class="title">性别</span>
                  <!-- <select v-model="sex" @change="updateSex($event)" class="gender-content">
                    <option :value="1">男</option>
                    <option :value="2">女</option>
                  </select> -->
                  <el-radio-group v-model="sex" @input="updateSex">
                    <el-radio :label="1">男</el-radio>
                    <el-radio :label="2">女</el-radio>
                  </el-radio-group>
                </div>
                <div class="tel">
                  <span class="title">手机号码</span>
                  <div class="tel-content">
                    <input v-model="phone" type="text" placeholder="请输入手机号码" disabled />
                    <span class="change-tel-bind" v-if="is_showphone_hidden" @click="handleCloseBindTel">更换绑定</span>
                  </div>
                </div>
                <div class="save-btn">
                  <button class="save-info" @click="updateUserInfo()">保存</button>
                </div>
              </form>
            </div>
            <!-- 表单结束 -->
            <!-- 改密表单 -->
            <ChangePassword v-if="gaimi" :areaCodeList="areaCodeList" />
            <BindWeChat v-if="bdwx"></BindWeChat>
          </div>
        </div>
        <!-- 手机改绑 -->
        <ChangeTel :areaCodeList="areaCodeList" @onCloseWindow="handleCloseBindTelChange" :telShow="bindTelShow" />
      </div>
    </div>

    <!-- <Bottom /> -->
    <Footer></Footer>
  </div>
</template>

<script>
import Banner from './banner'
// import Bottom from './bottom'
import Footer from './mofang/footer.vue'
import cebianlan from './cebianlan'
import course from './course'
import ChangeTel from './components/changeTel'
import ChangePassword from './components/changePassword.vue'
import BindWeChat from './components/BindWeChat.vue'
import oneVone from './oneVone'
import pingtest from './pingTest'
import MyNote from './note/noteIndex.vue'
import MyHomework from './myHomework/homeworkIndex.vue'
import ViewDataCon from './components/viewDataCon'
import NoticeQrCode from './components/NoticeQrCode.vue'
import { FileUploadType } from '@/utils/constant'
import { cosUpload } from '@/utils/cosUpload'
// import {
//   Toast
// } from 'vant'
// import COS from 'cos-js-sdk-v5'
import sendMessage from '../mixins/sendMessage'
import { mapState } from 'vuex'
// import { getOnlineApi } from '@/utils/useProxyApi'

export default {
  components: {
    Banner,
    // Bottom,
    Footer,
    cebianlan,
    course,
    ChangeTel,
    ChangePassword,
    oneVone,
    pingtest,
    MyHomework,
    ViewDataCon,
    MyNote,
    BindWeChat,
    NoticeQrCode
  },
  mixins: [sendMessage],
  data() {
    return {
      listArr: [
        { id: 0, name: '我的课程', url: require('./images/course@2x.png') },
        { id: 1, name: '我的作业', url: require('./images/homeWork@2x.png') },
        { id: 2, name: '观看数据', url: require('./images/view_data.png'), hide: true},
        { id: 3, name: '1V1约课', url: require('./images/class@2x.png') },
        { id: 4, name: '我的评测', url: require('./images/cp@2x.png') },
        { id: 5, name: '我的笔记', url: require('./images/myNote.png') },
        { id: 6, name: '账户中心', url: require('./images/账户.png') }
      ],
      currentIndex: 0,
      changePassword: {
        phone: '',
        area: '86',
        code: '',
        newPassword: '',
        is_showphone_hidden:false,
      },
      bindTelShow: false,
      changeTel: false,
      isCourse: true,
      isZhanghu: false,
      isYueKe:false,
      ziliao: true,
      gaimi: false,
      bdwx: false,
      codePhone: false,
      classA: 'nav-active',
      classMy: 'xuanzhong',
      classB: '',
      id: '',
      account: '',
      icon: '',
      sex: '',
      phone: '',
      nick_name: '',
      cos: null,
      classNum: '',
      areaCodeList: [],
      isPingTest:false,
      is_showphone_hidden:true,
      homework:false,
      isMyNote:'',
      unreadCount:0,
      isShowViewData: false,
      isEnableNotice: false,
    }
  },
  created() {
    this.getUserInfo()
    this.getAreaCode()
    this.homeworkListByClass()
    // this.getCourseHomeworkRead()
    // 初始化实例
    // this.cos = new COS({
    //   // getAuthorization 必选参数
    //   getAuthorization: function (options, callback) {
    //     // 异步获取临时密钥
    //     // 服务端 JS 和 PHP 例子：https://github.com/tencentyun/cos-js-sdk-v5/blob/master/server/
    //     // 服务端其他语言参考 COS STS SDK ：https://github.com/tencentyun/qcloud-cos-sts-sdk
    //     // STS 详细文档指引看：https://cloud.tencent.com/document/product/436/14048
    //     // const baseUrl = process.env.VUE_APP_API_ONLINE_SCHOOL
    //     const baseUrl = getOnlineApi()
    //     var url = `${baseUrl}/common/index/getCosSign` // url替换成您自己的后端服务
    //     var xhr = new XMLHttpRequest()
    //     xhr.open('GET', url, true)
    //     xhr.onload = function (e) {
    //       try {
    //         var data = JSON.parse(e.target.responseText)
    //         var credentials = data.data.credentials
    //       } catch (e) {
    //         console.log(e);
    //       }
    //       if (!data || !credentials) {
    //         return console.error(
    //           'credentials invalid:\n' + JSON.stringify(data, null, 2)
    //         )
    //       }
    //       callback({
    //         TmpSecretId: credentials.tmpSecretId,
    //         TmpSecretKey: credentials.tmpSecretKey,
    //         SecurityToken: credentials.sessionToken,
    //         // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
    //         StartTime: data.data.startTime, // 时间戳，单位秒，如：1580000000
    //         ExpiredTime: data.data.expiredTime, // 时间戳，单位秒，如：1580000000
    //       })
    //     }
    //     xhr.send()
    //   },
    // })

  },
  mounted() {
      this.setTabByRouteParam()
      this.getconfig()
      if (this.$route.query.setid=='100101') {
        this.myNote()
      }
  },
  beforeRouteEnter(to, from, next) {
      next(vm => {
        if(from.path == '/oneclass/' ) {
          vm.isYueKe = true
          vm.isCourse = false
          vm.isZhanghu = false
          vm.isPingTest = false
        }

    })
  },
  computed: {
    ...mapState(['org_id']),
  },
  methods: {
    selectList(item, index) {
      this.currentIndex = index
    },
    changeUnread(){
       this.homeworkListByClass()
    },
    homeworkListByClass(){
      const data = {
        page:1,
        page_nums:100000
      }
      this.$tenghuiApi.post('/onlineapi/user/index/homeworkListByClass', data).then(res=>{
        // console.log('[<-- 课程列表 -->]',res);
        if (res.data.code==200) {
          // console.log('sss111111111=====', res.data.data.count)
          // this.sykecheng = res.data.data.list
          // this.total = res.data.data.count
          let sum = 0
          res.data.data.list.forEach(item=>{
            sum += item.unread_count
          })
          this.unreadCount = sum
        }
      })
    },
    // getCourseHomeworkRead(){
    //   this.$tenghuiApi.post('/onlineapi/user/index/getCourseRead').then(res=>{
    //     console.log('[<-- res作业未读数 -->]',res);
    //     if (res.data.code==200) {
    //       this.unreadCount=res.data.data
    //     }
    //   })
    // },
    handleCloseBindTelChange(){
      this.bindTelShow=false
    },
    // 获取地区码
    async getAreaCode() {
      const res = await this.$axios.get('/common/index/areaCodes')
      const { data } = res
      if (data.code === 200) {
        this.areaCodeList = data.data
      }
    },
     async getconfig(){
      const res = await this.$axios.post('/user/index/config')
      const { data } = res
      if (data.code === 200) {
        let phone_hidden_obj = data.data.find(x=>x.key=='Online_school_mobile_phone_hidden')
        if (phone_hidden_obj) {
          this.is_showphone_hidden = phone_hidden_obj.value != 'true'
        }

        const courseReplayData = data.data.find(list => list.key ==='courseReplayData')
        if (courseReplayData) {
          this.listArr.forEach(element => {
            if (element.name === '观看数据') {
              element.hide = !(courseReplayData.value === 'true')
            }
          });
        }

      }
    },
    aziliao() {
      this.ziliao = true
      this.gaimi = false
      this.bdwx = false
    },
    agaimi() {
      this.ziliao = false
      this.gaimi = true
      this.bdwx = false
    },
    abdwx() {
      this.ziliao = false
      this.gaimi = false
      this.bdwx = true
    },
    openCodePhone() {
      this.codePhone = true
    },
    shutdown() {
      this.codePhone = false
    },

    choosePic() {
      this.$refs.updateFile.click()
    },
    handleCloseBindTel() {
      console.log('[<-- this.bindTelShow开始 -->]',this.bindTelShow);
      this.bindTelShow = true
      console.log('[<-- this.bindTelShow结束 -->]',this.bindTelShow);
    },
    // 上传头像
    async afterRead(e) {
      // 此时可以自行将文件上传至服务器
      let file = e.target.files[0]
      // this.cos.putObject(
      //   {
      //     Bucket: 'tengface-live-user-1308721187',
      //     /* 填入您自己的存储桶，必须字段 */
      //     Region: 'ap-guangzhou',
      //     /* 存储桶所在地域，例如ap-beijing，必须字段 */
      //     Key: new Date().getTime() + file.name,
      //     /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段 */
      //     StorageClass: 'STANDARD',
      //     Body: file, // 上传文件对象
      //     onProgress: function (progressData) {
      //       console.log(JSON.stringify(progressData))
      //     },
      //   },
      //   (err, data) => {
      //     console.log(err || data)
      //     if (data.statusCode === 200) {
      //       this.icon = `http://${data.Location}`
      //       this.updateHeaderInfo(this.icon)
      //       console.log(this.icon)
      //     }
      //   }
      // )
      const { url } = await cosUpload(file, false, FileUploadType.AVATAR)
      this.updateHeaderInfo(url)
    },

    // 修改用户头像
    updateHeaderInfo(imgurl) {
      const data = {
        icon: imgurl,
      }
      this.$axios.post('/user/index/updateUserInfo', data).then((res) => {
        if (res.data.code === 200) {
          this.$message({
            message: '修改成功',
            type: 'success',
          })
        }
      })
    },
    closeQrCodeDialog() {
      this.checkNoticeEnable()
      const timer = setInterval(() => {
        !this.isEnableNotice ? this.checkNoticeEnable() : clearInterval(timer)
      }, 5000)
    },
    checkNoticeEnable() {
      this.$axios.post('/user/index/getUserInfo').then(res => {
        if (res.data.code === 200) {
          this.isEnableNotice = !!res.data.data.openid
        }
      })
    },
    // 获取用户信息
    getUserInfo() {
      this.$axios.post('/user/index/getUserInfo').then((res) => {
        if (res.data.code === 200) {
          this.id = res.data.data.id
          localStorage.setItem('tengface_fans_id', res.data.data.id)
          this.account = res.data.data.account
          this.sex = res.data.data.sex
          this.phone = res.data.data.phone
          this.nick_name = res.data.data.nick_name
          this.icon = res.data.data.icon
          this.classNum = res.data.data.classNum
          this.isEnableNotice = !!res.data.data.openid
          localStorage.setItem('nick',this.nick_name)
        }
      })
    },
    updateSex() {
      const data = {
        sex: this.sex,
      }
      this.$axios.post('/user/index/updateUserInfo', data).then((res) => {
        if (res.data.code === 200) {
          this.list = res.data.data
        }
      })
    },
    // 修改用户信息
    updateUserInfo() {
      const data = {
        nick_name: this.nick_name,
      }
      this.$axios.post('/user/index/updateUserInfo', data).then((res) => {
        if (res.data.code === 200) {
          this.list = res.data.data
          this.$message({
            message: '保存成功',
            type: 'success',
          })
        }
      })
    },
    setTabByRouteParam() {
      const { tab, subTab } = this.$route.query
      if(!tab && !subTab) {
        return
      }
      this.currentIndex = tab - 1;
    }
  },
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.w {
  /* width: 1260px; */
  margin: 0 auto;
  min-width: 972px;
}

li {
  list-style: none;
}

a {
  text-decoration: none;
}

.nav {
  position: absolute;
  /* top: 28px; */
  left: 220px;
  height: 80px;
}
::v-deep .el-badge__content.is-fixed{
  top:30px;
  right: -5px;
}
.banner {
  width: 100%;
  background-color: #f5f6f7;
}

.banner .w {
  position: relative;
  overflow: hidden;
  display: flex;
}

.banner .w .zongshu {
  float: left;
  /* width: 300px; */
  height: 753px;
  background-color: #ffffff;
  margin-top: 20px;
  margin-bottom: 25px;
  position: relative;
}

.banner .w .zongshu .head-sculpture {
  float: left;
  width: 68px;
  height: 68px;
  border-radius: 50%;
  margin-top: 30px;
  overflow: hidden;
  margin-left: 20px;
  display: inline-block;
  background-position: center;
  background-size: cover;
}

.banner .w .zongshu .name {
  float: left;
  min-width: 68px;
  height: 68px;
  margin-top: 30px;
  margin-left: 20px;
}

.banner .w .zongshu .name p {
  font-size: 14px;
  color: #c9ccd2;
  padding-top: 20px;
}

.banner .w .zongshu .cw {
  float: left;
  height: 25px;
  margin-top: 15px;
  margin-left: 20px;
}

.banner .w .zongshu .cw img {
  width: 15px;
  height: 15px;
}

.banner .w .zongshu .cw p {
  font-size: 14px;
  height: 20px;
  padding-top: 20px;
}

.banner .w .zongshu .cw .tp::before {
  float: left;
  content: '';
  width: 20px;
  height: 20px;
  background: url(./images/lingdang.png) no-repeat;
}

.banner .w .zongshu .cw .just {
  position: absolute;
  top: 139px;
  left: 265px;
  color: #868c9a;
  font-size: 14px;
}

.banner .w .zongshu .tongji {
  float: left;
  width: 300px;
  height: 75px;
  margin-top: 20px;
}

.banner .w .zongshu .tongji div {
  float: left;
  width: 86px;
  height: 75px;
  margin-left: 10px;
  background-color: #f5f6f7;
}

.banner .w .zongshu .tongji div p {
  float: left;
  height: 15px;
  font-size: 14px;
  color: #868c9a;
  margin-top: 15px;
  padding-left: 10px;
}

.banner .w .zongshu .tongji .one::before {
  float: left;
  content: '60';
  margin-top: -5px;
  margin-left: 2;
  color: #10a675;
  font-size: 20px;
}

.banner .w .zongshu .tongji .two::before {
  float: left;
  content: '365';
  margin-top: -5px;
  margin-left: 2;
  color: #10a675;
  font-size: 20px;
}

.banner .w .zongshu .tongji .three::before {
  float: left;
  content: '12';
  margin-top: -5px;
  margin-left: 2;
  color: #10a675;
  font-size: 20px;
}

.banner .w .zongshu .neirong {
  float: left;
  /* width: 300px; */
  min-width: 250px;
  margin-top: 17px;
}

.banner .w .zongshu .neirong .ab {
  float: left;
  /* width: 300px; */
  height: 60px;
  margin-bottom: 10px;
  border-left: 10px solid #ffffff;
  transition: all 0.5s;
  cursor: pointer;
}

.banner .w .zongshu .neirong .ab:hover {
  /* background-color: #e2e5e8;
  border-left: 10px solid #10a675; */
}
.banner .w .zongshu .neirong .ab.xuanzhong{
  background-color: #e2e5e8;
  border-left: 10px solid #1872ED;
}

.banner .w .zongshu .neirong .ab img {
  float: left;
  width: 20px;
  height: 20px;
  margin-top: 20px;
  margin-left: 30px;
}

.banner .w .zongshu .neirong .ab span {
  float: left;
  height: 20px;
  margin-top: 14px;
  margin-left: 20px;
  font-size: 24px;
  color: #373737;
}

.banner .w .banner_r_h {
  float: right;
  width: 940px;
  height: 65px;
  margin-top: 25px;
  background-color: #ffffff;
}

.banner .w .banner_r_h .bt h2 {
  float: left;
  margin-top: 20px;
  margin-left: 30px;
}

/* .footer {
  position: relative;
  height: 232px;
} */

.footer .footer-t {
  height: 200px;
  background-color: #101115;
}

.footer .footer-t .fleft {
  position: absolute;
  top: 50px;
  left: 180px;
}

.fleft dl dt {
  font-size: 18px;
  color: #82858a;
  margin-bottom: 20px;
}

.fleft dl dd {
  padding-top: 15px;
}

.fleft dl dd a {
  font-size: 14px;
  color: #82858a;
}

.footer .footer-t .fmd {
  position: absolute;
  top: 25px;
  right: 200px;
  width: 250px;
  height: 160px;
}

.footer .footer-t .fmd p {
  font-size: 14px;
  color: #82858a;
  margin-top: 14px;
}

.footer .footer-t .fright img {
  position: absolute;
  top: 50px;
  right: 20px;
  width: 104px;
  height: 104px;
}

.footer .footer-t .fright p {
  position: absolute;
  bottom: 45px;
  right: 25px;
  font-size: 14px;
  color: #82858a;
}

.footer .footer-b {
  height: 50px;
  background-color: #0c0d10;
}

.footer .footer-b p {
  font-size: 14px;
  text-align: center;
  color: #82858a;
  line-height: 19px;
  padding-top: 15px;
}

.banner .w .banner_r_m {
  float: right;
  width: 940px;
  height: 750px;
  margin-top: 2px;
  margin-bottom: 30px;
  background-color: #ffffff;
}
/* 头部导航样式 */
.header {
  padding-left: 30px;
  padding-top: 20px;
  margin-bottom: 50px;
}
.header ul {
  display: flex;
}
.header ul li {
  width: 84px;
  height: 34px;
  color: #202020;
  text-align: center;
  line-height: 34px;
  color: #202020;
  font-size: 14px;
  border-radius: 17px;
  cursor: pointer;
}
.header ul li:first-child {
  margin-right: 14px;
}
.nav-active {
  color: #ffffff !important;
  background: linear-gradient(132deg,#73aaff 7%, #0053ff 95%);
}
/* 个人资料样式 */
.personal {
  padding: 0 228px;
}
.personal .title {
  font-size: 14px;
  color: #808695;
  width: 56px;
  margin-right: 24px;
}
.avatar,
.id,
.nickname,
.gender,
.tel {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
.id-content {
  background: #f5f6f7;
}
.avatar-img {
  width: 64px;
  height: 64px;
  overflow: hidden;
  border-radius: 50%;
  background-size: cover;
  background-position: center;
  overflow: hidden;
  margin-right: 20px;
}
.avatar-change {
  font-size: 14px;
  color: #1872ED;
  cursor: pointer;
}
.id-content,
.nickname-content,
.gender-content,
.tel-content {
  width: 404px;
  height: 44px;
  border: #e8eaec 1px solid;
  border-radius: 2px;
  box-sizing: border-box;
  padding-left: 16px;
  font-size: 14px;
  line-height: 44px;
}
.gender-content {
  outline: none;
}
.personal input {
  width: 100%;
  height: 100%;
  border: none;
  outline: none;
  background: transparent;
}
.tel-content {
  position: relative;
}
.change-tel-bind {
  position: absolute;
  color: #1872ED;
  width: 88px;
  right: 0;
  text-align: center;
  border-left: 1px #e8eaec solid;
  cursor: pointer;
}
.save-btn {
  margin-top: 30px !important;
  width: 200px;
  height: 40px;
  text-align: center;
  margin: 0 auto;
  color: #ffffff;
}
.save-btn button {
  width: 100%;
  height: 100%;
  border: none;
  background: linear-gradient(132deg,#73aaff 7%, #0053ff 95%);
  line-height: 40px;
  font-size: 16px;
  border-radius: 20px;
  color: #ffffff;
  cursor: pointer;
}

</style>
